<script lang="ts" context="module">
    
    import type { Form } from "../Model/Form";

    const formsCache = new Map<string, Promise<Form>>();

</script>

<script lang="ts">
    
    import { formsService } from "../services";

    export let formId: string;

    let formName: string = '';

    $: getFormName(formId);

    async function getFormName(formId: string): Promise<void> {
        if (!formId) {
            formName = '';
            return;
        }
        try {
            if (!formsCache.has(formId)) {
                formsCache.set(formId, formsService.findOne(formId));
            }
            const form = await formsCache.get(formId)!;
            formName = form.name;
        } catch (error) {
            console.error(error);
        }
    }

</script>

{formName}
